export default "__VITE_ASSET__D9Vn_K44__"